import React from 'react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import zhTW from 'antd/lib/locale-provider/zh_TW';
import enUS from 'antd/lib/locale-provider/en_US';
import esES from 'antd/lib/locale-provider/es_ES';
import frFR from 'antd/lib/locale-provider/fr_FR';
import jaJP from 'antd/lib/locale-provider/ja_JP';
import huHU from 'antd/lib/locale-provider/hu_HU';
import koKR from 'antd/lib/locale-provider/ko_KR';
import ptBR from 'antd/lib/locale-provider/pt_BR';
import deDE from 'antd/lib/locale-provider/de_DE';

import { detectLanguage, setLanguage, getLanguage, t, DEFAULT_LANG } from './i18n';

const LOCALES = {
  zh: zhCN,
  en: enUS,
  es: esES,
  fr: frFR,
  ja: jaJP,
  hu: huHU,
  ko: koKR,
  pt: ptBR,
  de: deDE,
  'zh-TW': zhTW,
};

export function getAntdLocale() {
  return LOCALES[getLanguage()] || zhCN;
}

// 语言 Context：Provider 初始化语言，组件通过 context 使用 t / changeLanguage
export const LanguageContext = React.createContext({
  lang: DEFAULT_LANG,
  t,
  changeLanguage: () => {},
});

export class LanguageProvider extends React.PureComponent {
  constructor(props) {
    super(props);
    const lang = detectLanguage();
    setLanguage(lang);
    this.state = { lang };
  }

  changeLanguage = (lang) => {
    const normalized = setLanguage(lang);
    try {
      window.localStorage.setItem('lang', normalized);
    } catch (e) {
      // ignore localStorage access errors
    }
    this.setState({ lang: normalized });
  };

  render() {
    const { children } = this.props;
    return (
      <ConfigProvider locale={getAntdLocale()}>
        <LanguageContext.Provider value={{ lang: this.state.lang, t, changeLanguage: this.changeLanguage }}>
          {children}
        </LanguageContext.Provider>
      </ConfigProvider>
    );
  }
}
